import { render, staticRenderFns } from "./RemoveCustomerDialog.vue?vue&type=template&id=7006824f&"
import script from "./RemoveCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveCustomerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports